import React from 'react';

export const IconLinkedIn = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 19H5V9H8V19ZM19 19H16V13.658C16 12.266 15.504 11.573 14.521 11.573C13.742 11.573 13.248 11.961 13 12.738V19H10C10 19 10.04 10 10 9H12.368L12.551 11H12.613C13.228 10 14.211 9.322 15.559 9.322C16.584 9.322 17.413 9.607 18.046 10.323C18.683 11.04 19 12.002 19 13.353V19Z"
      fill="#667085"
    />
    <path
      d="M6.49995 8C7.35599 8 8.04995 7.32843 8.04995 6.5C8.04995 5.67157 7.35599 5 6.49995 5C5.64391 5 4.94995 5.67157 4.94995 6.5C4.94995 7.32843 5.64391 8 6.49995 8Z"
      fill="#667085"
    />
  </svg>
);
